<template>
  <div class="stockCheck column-me">
    <div class="card-div column-me flex1">
      <div class="row-me row-center flex-wrap">
        <div class="flex1">
          <el-input placeholder="请输入盘点单号" style="width: 100%;" clearable v-model="number"></el-input>
        </div>
        <div class="flex1 margin-left20">
          <el-select v-model="selectHouse" placeholder="请选择库房" style="width: 100%;" filterable clearable>
            <el-option v-for="item in houseArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="flex1 margin-left20">
          <el-date-picker type="daterange" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
                          value-format="YYYY-MM-DD" clearable v-model="selectDate" style="width: 100%;">
          </el-date-picker>
        </div>
        <div class="row-me row-center margin-left20">
          <div class="btn-blue width100 btn-height40" @click="clickSearch">
            <el-icon>
              <search/>
            </el-icon>
            查询
          </div>
          <div class="btn-blank width100 btn-height40 margin-left20" @click="clickClear">清空</div>
        </div>
      </div>
      <div class="row-me row-center margin-top30" v-if="canOperate">
        <div class="btn-blue width160 btn-height40" @click="clickAdd">
          <el-icon>
            <plus/>
          </el-icon>
          新增盘点
        </div>
      </div>
      <div class="column-me flex1 margin-top20">
        <div>
          <el-table ref="tableStockCheck" :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" @row-click="clickTableRow">
            <el-table-column type="expand">
              <template #default="scope">
                <div class="margin-left15 margin-right15">
                  <el-table :data="scope.row.details" border header-cell-class-name="table-header-style"
                            cell-class-name="table-cell-style" height="100%">
                    <el-table-column prop="drugName" label="药品名称" align="center" width="150"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="spec" label="规格" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="unitName" label="单位" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="batchNo" label="批号" align="center" width="150"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column label="剂型" align="center" show-overflow-tooltip v-if="false">
                      <template v-slot="scope">
                        <div>{{ scope.row.drugType === 0 ? '常规剂型' : scope.row.drugType === 1 ? '颗粒剂型' : '' }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="validityTime" label="有效期" align="center" width="130"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="produceTime" label="生产日期" align="center" width="130"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="costPrice" label="入库价" align="center"
                                     show-overflow-tooltip></el-table-column>
                    <el-table-column prop="actualNums" label="实际数量" align="center" width="100"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="finishTime" label="时间节点" align="center" width="180"
                                     show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="subNums" label="盈亏数量" align="center" width="100" show-overflow-tooltip>
                      <template #default='scope'>
                        <div v-if="!this.$method.isEmpty(scope.row.actualNums)">
													<span class="orange-div"
                                v-if="Number(scope.row.actualNums)<Number(scope.row.bookNums)">亏</span>
                          <span class="blue-div"
                                v-if="Number(scope.row.actualNums)>Number(scope.row.bookNums)">盈</span>
                          <span class="green-div"
                                v-if="Number(scope.row.actualNums)===Number(scope.row.bookNums)">平</span>
                          {{ scope.row.subNums }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column prop="bookNums" label="账面数量" align="center" width="100" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="producerName" label="生产商" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="supplierName" label="供应商" align="center" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="productAddress" label="产地" align="center" show-overflow-tooltip>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="batchNo" label="盘点单号" align="center" width="200"></el-table-column>
            <el-table-column prop="pharmacyName" label="库房名称" align="center"></el-table-column>
            <el-table-column prop="startTime" label="盘点开始时间" align="center" width="220"></el-table-column>
            <el-table-column prop="endTime" label="盘点结束时间" align="center" width="220"></el-table-column>
            <el-table-column prop="createBy" label="盘点人员" align="center" width="120"></el-table-column>
            <el-table-column prop="status.name" label="状态" align="center" width="120"></el-table-column>
            <el-table-column prop="remark" label="备注" align="center"></el-table-column>
            <el-table-column label="操作列" width="380" align="left" v-if="canOperate">
              <template #header>
                <div class="margin-left20">操作列</div>
              </template>
              <template #default="scope">
                <div class="row-me row-center margin-left20">
                  <div class="btn-blue width110 btn-height40 margin-right10"
                       v-if="scope.row.status.value===0" @click.stop="clickEdit(scope.row)">修改
                  </div>
                  <div class="btn-blue width110 btn-height40 margin-right10"
                       v-if="scope.row.status.value===1" @click.stop="clickPing(scope.row)">平库
                  </div>
                  <div class="btn-grey width110 btn-height40 margin-right10"
                       v-if="scope.row.status.value===0||scope.row.status.value===1"
                       @click.stop="clickDelete(scope.row)">删除
                  </div>
                  <div class="btn-green width110 btn-height40" v-if="true"
                       @click.stop="clickExport(scope.row)">
                    <img src="../../assets/img/icon_daochu.png" class="img-icon">
                    <span>导出</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作列" width="150" align="center" v-else>
              <template #default="scope">
                <div class="row-me center-all">
                  <div class="btn-green width110 btn-height40" v-if="true"
                       @click.stop="clickExport(scope.row)">
                    <img src="../../assets/img/icon_daochu.png" class="img-icon">
                    <span>导出</span>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      number: '',
      selectHouse: '',
      selectDate: [],
      tableData: [],
      pageNo: 1,
      total: 0,
      houseArray: [], //库房列表
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getHouseList()
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickTableRow(row, index, e) {
      if (this.$method.isEmpty(row.details)) {
        this.bus.$emit('loading', 1)
        this.$getRequest('/admin/stock/detailStockCheck', {
          id: row.id
        }).then((res) => {
          if (res) {
            row.details = res.data
            this.$nextTick(() => {
              this.bus.$emit('loading', 0)
              this.$refs.tableStockCheck.toggleRowExpansion(row)
            })
          }
        }).catch((error) => {
          console.log(error)
        })
      } else {
        this.$refs.tableStockCheck.toggleRowExpansion(row)
      }
    },
    //查询
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    //清空
    clickClear() {
      this.number = ''
      this.selectHouse = ''
      this.selectDate = []
      this.pageNo = 1
      this.getData()
    },
    //新增
    clickAdd() {
      this.$router.push({
        path: '/addStockCheck'
      })
    },
    //修改
    clickEdit(item) {
      this.$router.push({
        path: '/addStockCheck',
        query: {
          id: item.id
        }
      })
    },
    //删除
    clickDelete(item) {
      this.$confirm("您确定要删除吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postRequest('/admin/stock/deleteStockCheck/' + item.id, {}).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //平库
    clickPing(item) {
      this.$confirm("您确定要平库吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/stock/flatStock', {
          id: item.id
        }).then((res) => {
          if (res) {
            this.$message.success('平库成功')
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //导出
    clickExport(item) {
      let token = sessionStorage.getItem('token')
      let url = this.$baseUrl + '/admin/stock/exportCountPhaDetails?id=' + item.id + '&token=' + token
      window.open(url)
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/stock/pageStockCheck', {
        batchNo: this.number,
        pharmacyId: this.selectHouse,
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取库房列表
    getHouseList() {
      this.$getRequest('/admin/pharmacy/listAll', {}).then((res) => {
        if (res) {
          this.houseArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.stockCheck {
  height: 100%;

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;
  }

  .orange-div {
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    background-color: darkorange;
    padding: 1px 2px;
    border-radius: 2px;
  }

  .blue-div {
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    background-color: dodgerblue;
    padding: 1px 2px;
    border-radius: 2px;
  }

  .green-div {
    text-align: center;
    font-size: 15px;
    color: #FFFFFF;
    background-color: limegreen;
    padding: 1px 2px;
    border-radius: 2px;
  }
}
</style>
